
const QUOTATIONS_COLUMN = [
    {
        Header: "#",
        accessor: ""
    },
    {
        Header: "ID",
        accessor: "id",
    },
    {
        Header: "Name",
        accessor: "mapUserPatient.User.name"
    },
    {
        Header: "EndDate",
        accessor: "endDate",
    },
    {
        Header: "Duration",
        accessor: "noOfDays",
    },
    {
        Header: "Partner",
        accessor: "partner.name"
    },
    {
        Header: "Left",
        accessor: "daysLeft",
    },
    {
        Header: "Total Amount(₹)",
        accessor: "total",
    },
    {
        Header: "Inventory No",
        accessor: "inventoryId",
    },
    {
        Header: "Fulfillment %",  // ← NEW COLUMN
        accessor: "fulfillmentPercentage",
    },
];

const COLUMNS_FUCTIONALITIES = {
    "PRESORTED_QUOTATIONS": ['PrintMultipleAddress', "Reorder", "Delete", "Edit", "Status", "DownloadExcel", "selectAllRows"],
    "STRIPS_QUOTATIONS": ['PrintMultipleAddress', "Reorder", "Delete", "Edit", "Status", "DownloadExcel", "selectAllRows"],
    "ALL_QUOTATIONS": ['PrintMultipleAddress', "Reorder", "Delete", "Edit", "Status", "DownloadExcel", "selectAllRows"],
    // src/v2/pharmacy/pages/quotations. No "Reorder" -- that flow has its own screen.
    "PHARMACY_QUOTATIONS": ['PrintMultipleAddress', "Delete", "Edit", "Status", "DownloadExcel", "selectAllRows"],
    "SALES_QUOTATIONS": ['PrintMultipleAddress', "Edit", "Status", "DownloadExcel", "selectAllRows"],
}

const STATUS_MAP = {
    'QUOTATION_ACTIVE': 'ACTIVE',
    'QUOTATION_PENDING': 'PENDING',
    'QUOTATION_INACTIVE': 'INACTIVE',
    'QUOTATION_CANCELLED': 'CANCELLED',
    'QUOTATION_UPLOADRX': 'UPLOADRX',
    'CALL_PENDING': 'CALL_PENDING',
    'CALL_PICKED': 'CALL_PICKED',
    'RX_SENT': 'RX_SENT',
    'RX_SEND': 'RX_SEND',
    'USER_DRX_PENDING': 'USER_DRX_PENDING',
    'USER_DRX_ACCEPTED': 'USER_DRX_ACCEPTED',
    'USER_DRX_REJECTED': 'USER_DRX_REJECTED',
    'PAYMENT_PENDING': 'PAYMENT_PENDING',
    'PAYMENT_CONFIRMED': 'PAYMENT_CONFIRMED',
    'PAYMENT_FAILED': 'PAYMENT_FAILED',
    'PAYMENT_CANCELLED': 'PAYMENT_CANCELLED',
    'MANUAL_INTERVENTION': 'MANUAL_INTERVENTION'
};

const STATUS_MAP_REVERSE = Object.fromEntries(Object.entries(STATUS_MAP).map(([key, value]) => [value, key]));


export { QUOTATIONS_COLUMN, COLUMNS_FUCTIONALITIES, STATUS_MAP, STATUS_MAP_REVERSE };